import React from 'react';
import { ConfirmationPage } from 'src/components/ConfirmationPage';
export const ConfirmationPagePopupComponent = ({ popup }) => {
    const { title, subtitle, button, image, onConfirm } = popup.params;
    return React.createElement(ConfirmationPage, { title: title, image: image, subtitle: subtitle, button: button, onConfirm: onConfirm });
};
